import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLeftSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m6.407 8 4.297-4.297L9.29 2.289 3.579 8l5.711 5.711 1.414-1.414L6.407 8z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default IconArrowLeftSizeS;
